import React from 'react';

export default function Preloader({ show }) {
  return (
    <div
      className={`preloader${show ? " is-on" : ""}`}
      role="progressbar"
      aria-hidden={!show}
      aria-valuetext={show ? "Loading" : undefined}
    >
      <span className="preloader__bar" />
    </div>
  );
}
